import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { ElementMarker33ojvsajwmzts as ElementMarker } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/ElementMarker.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readIfAbsent($this, descriptor, index) {
  $this.s2r_1 = (!descriptor.k1p(index) && descriptor.j1p(index).v1o());
  return $this.s2r_1;
}
function JsonElementMarker$readIfAbsent$ref(p0) {
  return constructCallableReference((p0_0, p1) => {
    var tmp0 = p0;
    return readIfAbsent(tmp0, p0_0, p1);
  }, 2, 0, 43, 'readIfAbsent', [p0]);
}
var JsonElementMarkerClass;
function JsonElementMarker() {
  if (JsonElementMarkerClass === VOID) {
    class $ {
      constructor(descriptor) {
        var tmp = this;
        tmp.r2r_1 = new (ElementMarker())(descriptor, JsonElementMarker$readIfAbsent$ref(this));
        this.s2r_1 = false;
      }
      t2r(index) {
        this.r2r_1.g1x(index);
      }
      u2r() {
        return this.r2r_1.h1x();
      }
    }
    initMetadataForClass($, 'JsonElementMarker');
    JsonElementMarkerClass = $;
  }
  return JsonElementMarkerClass;
}
//region block: exports
export {
  JsonElementMarker as JsonElementMarker395jk2pil4789,
};
//endregion

//# sourceMappingURL=JsonElementMarker.mjs.map
